import axios from "axios";
import {endpoint} from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export const getAutoSuggest = ({ userInput }) => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/search/autocomplete`, {
      params: {
        query: userInput
      },
      withCredentials: false
    })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};
